import React from "react";

import { Icon, PlainButton, classnames } from "@culturehq/components";
import { LANGUAGE_CODES } from "../../utils/constants";

interface SubtitleOptionProps {
  activeLanguageCode?: string;
  changingLanguage: boolean;
  language: string;
  onChangeLanguage: (language: string) => void;
}

const SubtitleOption: React.FC<SubtitleOptionProps> = ({
  activeLanguageCode,
  changingLanguage,
  language,
  onChangeLanguage
}) => (
  <li role="navigation">
    <PlainButton
      className={classnames({ active: activeLanguageCode === language })}
      disabled={changingLanguage}
      onClick={() => { onChangeLanguage(language); }}
    >
      {activeLanguageCode === language && <Icon icon="checkmark" />}
      {LANGUAGE_CODES[language]}
    </PlainButton>
  </li>
);

export default SubtitleOption;
